import React from 'react';
import Accordion from '../components/ui/Accordion';
import { faqData } from '../data/mockData';

const Info = () => {
  return (
    <div className="container mx-auto px-6 md:px-12 py-12 animate-fade-in max-w-4xl">
      <h1 className="text-4xl md:text-5xl font-serif mb-12 text-center">Information & Guides</h1>

      <div className="mb-16">
        <h2 className="text-2xl font-serif mb-6 text-ultramarine">Framing Guide</h2>
        <div className="bg-white p-8 border border-gray-100 shadow-sm">
          <p className="mb-6 text-gray-600 leading-relaxed">
            Choosing the right frame is essential to protecting and presenting your art. All our frames include a 2-inch acid-free white mat border to give the artwork breathing room and prevent it from touching the acrylic glazing.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-8">
            <div>
              <h4 className="font-medium mb-2">Gallery Black</h4>
              <p className="text-sm text-gray-500">A classic, bold choice. Perfect for high-contrast photography and modern spaces.</p>
            </div>
            <div>
              <h4 className="font-medium mb-2">Gallery White</h4>
              <p className="text-sm text-gray-500">Seamless and contemporary. Blends beautifully with light walls for a minimalist look.</p>
            </div>
            <div>
              <h4 className="font-medium mb-2">Natural Oak</h4>
              <p className="text-sm text-gray-500">Warm and organic. Adds texture and pairs well with earthy tones and landscapes.</p>
            </div>
          </div>
        </div>
      </div>

      <div className="mb-16">
        <h2 className="text-2xl font-serif mb-6 text-ultramarine">Frequently Asked Questions</h2>
        <div className="border-t border-gray-200">
          {faqData.map((faq, index) => (
            <Accordion key={index} title={faq.question} content={faq.answer} />
          ))}
        </div>
      </div>

      <div>
        <h2 className="text-2xl font-serif mb-6 text-ultramarine">Shipping & Returns</h2>
        <div className="prose text-gray-600 max-w-none">
          <p className="mb-4">We take great care in packaging our artwork to ensure it arrives in pristine condition. Framed prints are shipped in custom-built corrugated boxes with substantial corner protection. Unframed prints are carefully rolled in acid-free tissue paper and shipped in heavy-duty craft tubes.</p>
          <ul className="list-disc pl-5 space-y-2 mb-4 text-sm">
            <li>Standard Shipping (5-7 business days): Free</li>
            <li>Expedited Shipping (2-3 business days): Calculated at checkout</li>
            <li>International Shipping: Varies by destination</li>
          </ul>
          <p>If your piece arrives damaged, please contact us within 48 hours with photos of the packaging and artwork, and we will arrange a replacement immediately.</p>
        </div>
      </div>
    </div>
  );
};

export default Info;